export default __webpack_public_path__ + "d6f9034b8a2185d8a20b0ce9c439fdc6.png";